import { Divider } from '@material-ui/core'
import React, { useRef, useState } from 'react'
import { FiActivity, FiDownloadCloud } from 'react-icons/fi'
import Flex from 'typescript-styled-flex'
import { MenuLinkItem } from '../../../../../components/Template/Header'
import Popover from '../../../../../components/Template/Popover'
import Calendar from './Calendar'
import Integrations from './Integrations'
import Synchronization from './Synchronization'

function DeveloperTools({ isSyncing }: IDeveloperToolsProps) {
  const refMenu = useRef(null)
  const [isOpen, setIsOpen] = useState(false)

  function togglePopper() {
    setIsOpen(!isOpen)
  }

  return (
    <React.Fragment>
      <MenuLinkItem ref={refMenu} center={true} onClick={togglePopper}>
        {isSyncing ? <FiDownloadCloud /> : <FiActivity />}
      </MenuLinkItem>
      {refMenu && refMenu.current && isOpen && (
        <Popover
          open={isOpen}
          onClose={togglePopper}
          anchorEl={refMenu.current}
          anchorOrigin={{
            horizontal: 'center',
            vertical: 'bottom',
          }}
          transformOrigin={{
            horizontal: 'center',
            vertical: 'top',
          }}
          withArrow={true}
        >
          <Flex column={true}>
            <Calendar />
            <Divider />
            <Divider />
            <Integrations />
            <Divider />
            <Synchronization />
          </Flex>
        </Popover>
      )}
    </React.Fragment>
  )
}

export default DeveloperTools

export interface IDeveloperToolsProps {
  isSyncing: boolean
}
